import { App } from '../AppManager';

interface ManifestGeneratorOptions {
  appData: App;
}

export const generateManifest = ({ appData }: ManifestGeneratorOptions): object => {
  // Determine theme color and background color
  let themeColor = '#4169e1'; // Default accent color
  let backgroundColor = '#ffffff'; // Default background
  
  if (appData.theme) {
    if (appData.theme.custom) {
      // Use topbarBackgroundColor for custom themes
      themeColor = appData.theme.custom.topbarBackgroundColor;
      backgroundColor = appData.theme.custom.backgroundColor;
    } else {
      // Use accent color for default themes
      themeColor = appData.theme.accentColor;
      // Set background based on theme variant
      backgroundColor = appData.theme.variant === 'modern-dark' ? '#1a1a1a' : '#ffffff';
    }
  }

  const manifestData = {
    short_name: appData.name,
    name: appData.name,
    icons: [
      {
        src: "favicon.png",
        sizes: "64x64 32x32 24x24 16x16",
        type: "image/png"
      },
      {
        src: "favicon.png",
        sizes: "192x192",
        type: "image/png"
      },
      {
        src: "favicon.png",
        sizes: "512x512",
        type: "image/png"
      }
    ],
    start_url: ".",
    display: "standalone",
    theme_color: themeColor,
    background_color: backgroundColor,
    description: `Order online from ${appData.name}`,
    categories: ["food", "business"],
    orientation: "portrait-primary"
  };

  return manifestData;
};

export const generateManifestFile = (options: ManifestGeneratorOptions): { content: string; filename: string } => {
  const manifestData = generateManifest(options);
  const content = JSON.stringify(manifestData, null, 2);
  const filename = `manifest.json.${options.appData.id}`;
  
  return {
    content,
    filename
  };
};